<div *ngIf="article !== undefined" class="shopping-cart-item">

    <img class="article-image" [src]="article.image" [alt]="article.name">
  
    <div class="article-name">{{ article.name }}</div>
  
    <div class="article-count">{{ count }}</div>
  </div>
